import React from 'react';
import { reduxWrapper } from '@common/redux/store';
import {
  loadRecommendationsForHotelsHotels,
  loadRecommendationsForHotelsPlacesNear,
  loadRecommendationsForHotelsRestaurantsNear,
} from '@common/redux/slices/recommendation.slice';
import { NotFoundPage } from '@kursk/components/pages/404/NotFoundPage';
import { loadHotel } from "@common/redux/slices/hotels.slice";
import { SingleHotel } from "@kursk/components/pages/SingleHotel/SingleHotel";
import { placePageProps } from "@kursk/utils/entitiesPages";
import { loadFeedbacks } from "@common/redux/slices/feedbacks.slice";

export default function page({ notFound }) {

  if (notFound) {
    return (<NotFoundPage/>);
  }
  return (
    <SingleHotel />
  );
}

export const getServerSideProps = reduxWrapper.getServerSideProps(async ({ store, params, req }) => {
  const { id } = params;
  await Promise.all([
    store.dispatch<any>(loadHotel({ _id: id })),
    store.dispatch<any>(loadRecommendationsForHotelsPlacesNear({ _id: id })),
    store.dispatch<any>(loadRecommendationsForHotelsRestaurantsNear({ _id: id })),
    store.dispatch<any>(loadRecommendationsForHotelsHotels({ _id: id })),
    store.dispatch<any>(loadFeedbacks({ type: 'hotel', hotelId: Number(id) })),
  ]);
  const { hotel } = store.getState().hotelsList;
  return placePageProps(hotel, req);
});
